import { Bindings } from '@coveo/atomic';
import { Result, loadGenericAnalyticsActions } from '@coveo/headless';

export async function customProductEventDispatcher(name: string, product: Result, bindings: Bindings, optionalConfig: object): Promise<void> {
    const {logCustomEvent} = loadGenericAnalyticsActions(bindings.engine);
    await bindings.engine.dispatch(
      logCustomEvent({
        evt: name,
        type: name,
        meta: {
          clickUri: product.clickUri,
          title: product.title,
          ...product.raw,
          ...optionalConfig,
        }
      })
    );
    
    dispatchCustomEvent(name, {
        product,
        ...optionalConfig,
    });
}


export function dispatchCustomEvent(name: string, options: any) {
    const event = new CustomEvent(name, {
        detail: {
            ...options,
        }
    });
    document.dispatchEvent(event);
}

export function encodeForDomAttribute(str: string) {
  return str
    .split("")
    .map((ch) => (ch.match(/(\d|\w)+/g) ? ch : ch.charCodeAt(0)))
    .join("");
}